import {
  Action,
  configureStore,
  Middleware,
  ThunkAction
} from '@reduxjs/toolkit';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE
} from 'redux-persist';
import { addressesApi } from 'services/addressesApi';
import { bookingApi } from 'services/bookingApi';
import { locationsApi } from 'services/locationsApi';
import { packagesApi } from 'services/packagesApi';
import { paymentMethodsApi } from 'services/paymentMethodsApi';
import { productsApi } from 'services/productsApi';
import { shoppingCartApi } from 'services/shoppingCartApi';
import { siteAlertsApi } from 'services/siteAlert';
import { userProfileApi } from 'services/userProfileApi';

import authMiddleware from 'store/middlewares/authMiddleware';

import persistedReducer from './rootReducer';

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }).concat([
      siteAlertsApi.middleware as Middleware,
      locationsApi.middleware as Middleware,
      productsApi.middleware as Middleware,
      userProfileApi.middleware as Middleware,
      shoppingCartApi.middleware as Middleware,
      addressesApi.middleware as Middleware,
      packagesApi.middleware as Middleware,
      bookingApi.middleware as Middleware,
      paymentMethodsApi.middleware as Middleware,
      authMiddleware
    ])
});

export const makeStore = () => store;

export const persist = persistStore(store);

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
